export const environment = {
  production: false,
  currentEnvironment: 'rc',
  BASE_API_URL: '/',
  SENTRY_DSN: 'https://f7a6004832fcab3aa453a0aa28e5c306@business-rc.bcc.kz/3',
};
